import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'wrapFn' })
export class CoreWrapFnPipe implements PipeTransform {
  transform<T>(fn: (...arg: any[]) => T, ...args: unknown[]): T {
    return fn(...args);
  }
}
